import(/* webpackMode: "eager" */ "/private/tmp/statura-proddeploy-DNF9tE/apps/web/src/app/global-error.tsx");
